var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _circle, _circle2, _circle3, _circle4, _circle5, _circle6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewSupplymintLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.929443,
    y: 0.398438,
    width: 32,
    height: 32,
    rx: 5.5,
    fill: "#5D5FEF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 15.978,
    y: 8.85156,
    width: 1.42857,
    height: 7.61905,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 15.9319,
    y: 7.71094,
    width: 1.42857,
    height: 12.6355,
    transform: "rotate(51.8154 15.9319 7.71094)",
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 16.2244,
    y: 16.7266,
    width: 1.42857,
    height: 10.6152,
    transform: "rotate(33.096 16.2244 16.7266)",
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 6.27539,
    y: 16.7031,
    width: 1.42857,
    height: 10.6152,
    transform: "rotate(-24.7049 6.27539 16.7031)",
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 26.3057,
    y: 16.0625,
    width: 1.42857,
    height: 10.0032,
    transform: "rotate(27.4657 26.3057 16.0625)",
    fill: "white"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 5.92798,
    y: 17.3203,
    width: 1.42857,
    height: 18.4822,
    transform: "rotate(-62.2575 5.92798 17.3203)",
    fill: "white"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 27.1648,
    y: 16.4141,
    width: 1.42857,
    height: 18.6323,
    transform: "rotate(62.9104 27.1648 16.4141)",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.9306,
    cy: 7.87351,
    r: 1.90476,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.9306,
    cy: 16.4594,
    r: 1.90476,
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.40696,
    cy: 16.4594,
    r: 1.90476,
    fill: "white"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.2168,
    cy: 25.0141,
    r: 1.90476,
    fill: "white"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 26.4546,
    cy: 16.4594,
    r: 1.90476,
    fill: "white"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 22.645,
    cy: 25.0141,
    r: 1.90476,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewSupplymintLogo);
export default __webpack_public_path__ + "static/media/NewSupplymintLogo.71d62a0b0688673aa1d50290c0fd1cd0.svg";
export { ForwardRef as ReactComponent };